<template>
  <div
    class="flex items-center justify-center space-x-2 h-[20px]"
    content="Aguardando resultado..."
    v-tippy="{ arrow: true, theme: 'green' }"
  >
    <div
      v-for="(dot, index) in dots"
      :key="index"
      class="h-2 w-2 rounded-full transition"
      :class="dot.highlight ? 'bg-ontick-steel-400' : 'bg-ontick-steel-500'"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dots: [
        {
          highlight: true,
        },
        {
          highlight: false,
        },
        {
          highlight: false,
        },
      ],
      interval: null,
    };
  },
  mounted() {
    this.interval = setInterval(() => {
      const activeIndex = this.dots.findIndex((item) => item.highlight);
      const max = this.dots.length - 1;
      this.dots[activeIndex].highlight = false;
      if (activeIndex + 1 > max) {
        this.dots[0].highlight = true;
      } else {
        this.dots[activeIndex + 1].highlight = true;
      }
    }, 500);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style></style>
